import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const UrgentCare = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="urgent care icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.0065 7.00037L22.5773 18.2121C22.4777 18.6722 22.0707 19.0004 21.6 19.0004H10.4065L8.23987 29.0004H19C19.3024 29.0004 19.5885 29.1372 19.7784 29.3726C19.9682 29.608 20.0414 29.9166 19.9773 30.2122L17.6399 41H28.7935L31.2227 29.7886C31.3224 29.3286 31.7293 29.0004 32.2 29.0004H43.3935L45.5601 19.0004H34.8C34.4976 19.0004 34.2115 18.8636 34.0216 18.6282C33.8318 18.3928 33.7587 18.0842 33.8227 17.7886L36.1601 7.00004L25.0065 7.00037ZM24.2 5.00039L37.4 5C37.7024 4.99999 37.9885 5.13682 38.1784 5.37219C38.3682 5.60757 38.4414 5.91621 38.3773 6.21175L36.0399 17.0004H46.8C47.1024 17.0004 47.3886 17.1372 47.5784 17.3726C47.7682 17.608 47.8414 17.9166 47.7773 18.2121L45.1773 30.2121C45.0777 30.6722 44.6707 31.0004 44.2 31.0004H33.0065L30.5773 42.2118C30.4777 42.6718 30.0707 43 29.6 43H16.4C16.0976 43 15.8115 42.8632 15.6216 42.6278C15.4318 42.3924 15.3586 42.0838 15.4227 41.7882L17.7601 31.0004H7C6.69761 31.0004 6.41146 30.8636 6.22162 30.6282C6.03178 30.3928 5.95864 30.0842 6.02268 29.7886L8.62268 17.7886C8.72235 17.3286 9.12932 17.0004 9.6 17.0004H20.7935L23.2227 5.78864C23.3223 5.32864 23.7293 5.00041 24.2 5.00039Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 9.39502C9 8.84273 9.44772 8.39502 10 8.39502H18C18.5523 8.39502 19 8.84273 19 9.39502C19 9.9473 18.5523 10.395 18 10.395H10C9.44772 10.395 9 9.9473 9 9.39502Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 13.395C4 12.8427 4.44772 12.395 5 12.395H13C13.5523 12.395 14 12.8427 14 13.395C14 13.9473 13.5523 14.395 13 14.395H5C4.44772 14.395 4 13.9473 4 13.395Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 36.395C0 35.8427 0.447715 35.395 1 35.395H9C9.55229 35.395 10 35.8427 10 36.395C10 36.9473 9.55229 37.395 9 37.395H1C0.447715 37.395 0 36.9473 0 36.395Z"
    />
  </svg>
)
